import React, { useEffect, useState } from 'react';
import { H1, UserContainer, UsersTable, UsersTableBody, UsersTableHead, UsersTableHeadColumn, UsersTableBodyColumn, UsersTableRow, Pill } from './style';
import axios from 'axios';
import AuthService from '../../../AuthService';
import Button from '../../../Components/Miscellaneous/Button';
import { FiEdit } from "react-icons/fi";
import { PaginationButton, PaginationContainer } from '../../Categories/style';
import { Input } from '../../Login/style';
import { MdPerson, MdCheckCircle } from 'react-icons/md';
import Card from '../../../Components/Miscellaneous/Card';

export default function Users() {
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [activeTab, setActiveTab] = useState('all'); // 'all', 'active', 'inactive'
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await axios.get('https://api.rb.beeapp.es/admin/users?limit=5000', {
                headers: {
                    'Authorization': 'Bearer ' + AuthService.getToken()
                }
            });
            const data = response.data;
            setUsers(data.results || []);
            setFilteredUsers(data.results || []);
            setTotalPages(data.totalPages || 1);
            setCurrentPage(data.currentPage || 1);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching users:', error);
            setLoading(false);
        }
    };

    // Filtrar usuarios por búsqueda y tabs
    useEffect(() => {
        let filtered = [...users];

        // Filtrar por tab
        if (activeTab === 'active') {
            filtered = filtered.filter(u => u.isVerified);
        } else if (activeTab === 'inactive') {
            filtered = filtered.filter(u => !u.isVerified);
        }

        // Filtrar por búsqueda
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase();
            filtered = filtered.filter(u =>
                (u.Name && u.Name.toLowerCase().includes(query)) ||
                (u.Surname && u.Surname.toLowerCase().includes(query)) ||
                (u.Email && u.Email.toLowerCase().includes(query)) ||
                (u.CIF && u.CIF.toLowerCase().includes(query))
            );
        }

        setFilteredUsers(filtered);
    }, [searchQuery, activeTab, users]);

    const totalUsers = users.length;
    const activeUsers = users.filter(u => u.isVerified).length;
    const inactiveUsers = users.filter(u => !u.isVerified).length;

    return (
        <UserContainer>
            {/* Header simple sin fondo */}
            <div style={{
                marginBottom: '32px'
            }}>
                <H1 style={{ color: '#028322', fontSize: '2rem', marginBottom: '8px', fontWeight: '600' }}>
                    Gestión de Usuarios
                </H1>
                <p style={{ fontSize: '1rem', color: '#028322', margin: 0 }}>
                    Administra las cuentas registradas en la plataforma
                </p>
            </div>

            {/* Barra de búsqueda y tabs */}
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                padding: '20px',
                marginBottom: '24px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                border: '1px solid #e5e7eb'
            }}>
                <Input
                    type="text"
                    placeholder="Buscar por nombre, email, CIF..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                        width: '100%',
                        marginBottom: '16px',
                        padding: '12px 16px',
                        fontSize: '14px',
                        borderRadius: '8px',
                        border: '1px solid #d1d5db'
                    }}
                />

                {/* Tabs */}
                <div style={{
                    display: 'flex',
                    gap: '12px',
                    borderBottom: '2px solid #f3f4f6',
                    paddingBottom: '0'
                }}>
                    <button
                        onClick={() => setActiveTab('all')}
                        style={{
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            border: 'none',
                            backgroundColor: 'transparent',
                            color: activeTab === 'all' ? '#028322' : '#6b7280',
                            borderBottom: activeTab === 'all' ? '3px solid #028322' : '3px solid transparent',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                    >
                        Todos ({totalUsers})
                    </button>
                    <button
                        onClick={() => setActiveTab('active')}
                        style={{
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            border: 'none',
                            backgroundColor: 'transparent',
                            color: activeTab === 'active' ? '#028322' : '#6b7280',
                            borderBottom: activeTab === 'active' ? '3px solid #028322' : '3px solid transparent',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                    >
                        Activos ({activeUsers})
                    </button>
                    <button
                        onClick={() => setActiveTab('inactive')}
                        style={{
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            border: 'none',
                            backgroundColor: 'transparent',
                            color: activeTab === 'inactive' ? '#028322' : '#6b7280',
                            borderBottom: activeTab === 'inactive' ? '3px solid #028322' : '3px solid transparent',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                    >
                        Inactivos ({inactiveUsers})
                    </button>
                </div>
            </div>

            {/* Tarjetas de estadísticas */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '20px',
                marginBottom: '32px'
            }}>
                <Card xs style={{
                    background: 'white',
                    border: '2px solid #028322',
                    borderRadius: '12px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                            <div style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
                                Total Usuarios
                            </div>
                            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1f2937' }}>
                                {totalUsers}
                            </div>
                        </div>
                        <MdPerson size={48} style={{ color: '#028322' }} />
                    </div>
                </Card>

                <Card xs style={{
                    background: 'white',
                    border: '2px solid #028322',
                    borderRadius: '12px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                            <div style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '8px', fontWeight: '500' }}>
                                Usuarios Activos
                            </div>
                            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#1f2937' }}>
                                {activeUsers}
                            </div>
                        </div>
                        <MdCheckCircle size={48} style={{ color: '#028322' }} />
                    </div>
                </Card>
            </div>

            {/* Tabla de usuarios */}
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                border: '1px solid #e5e7eb'
            }}>
                <UsersTable>
                    <UsersTableHead>
                        <UsersTableRow>
                            <UsersTableHeadColumn style={{ width: '90px', maxWidth: '90px' }}>CIF</UsersTableHeadColumn>
                            <UsersTableHeadColumn>NOMBRE</UsersTableHeadColumn>
                            <UsersTableHeadColumn>APELLIDO</UsersTableHeadColumn>
                            <UsersTableHeadColumn style={{ width: '180px', maxWidth: '180px' }}>EMAIL</UsersTableHeadColumn>
                            <UsersTableHeadColumn>TELÉFONO</UsersTableHeadColumn>
                            <UsersTableHeadColumn>ESTADO</UsersTableHeadColumn>
                            <UsersTableHeadColumn>ROL</UsersTableHeadColumn>
                            <UsersTableHeadColumn>ORGANIZACIÓN</UsersTableHeadColumn>
                            <UsersTableHeadColumn style={{ width: '80px' }}>ACCIONES</UsersTableHeadColumn>
                        </UsersTableRow>
                    </UsersTableHead>
                    <UsersTableBody>
                        {loading ? (
                            <UsersTableRow>
                                <UsersTableBodyColumn colSpan={9} style={{ textAlign: 'center', padding: '40px' }}>
                                    Cargando usuarios...
                                </UsersTableBodyColumn>
                            </UsersTableRow>
                        ) : filteredUsers.length === 0 ? (
                            <UsersTableRow>
                                <UsersTableBodyColumn colSpan={9} style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
                                    No se encontraron usuarios
                                </UsersTableBodyColumn>
                            </UsersTableRow>
                        ) : (
                            filteredUsers.map((user, index) => (
                                <UsersTableRow key={index} style={{
                                    transition: 'all 0.2s',
                                    cursor: 'pointer'
                                }}>
                                    <UsersTableBodyColumn style={{
                                        width: '90px',
                                        maxWidth: '90px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        {user.CIF || '-'}
                                    </UsersTableBodyColumn>
                                    <UsersTableBodyColumn style={{ fontWeight: '500' }}>
                                        {user.Name || '-'}
                                    </UsersTableBodyColumn>
                                    <UsersTableBodyColumn>{user.Surname || '-'}</UsersTableBodyColumn>
                                    <UsersTableBodyColumn style={{
                                        color: '#6b7280',
                                        width: '180px',
                                        maxWidth: '180px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    }}>
                                        {user.Email}
                                    </UsersTableBodyColumn>
                                    <UsersTableBodyColumn>
                                        {user.Phone || '-'}
                                    </UsersTableBodyColumn>
                                    <UsersTableBodyColumn>
                                        <Pill color={user.isVerified ? "#10b981" : "#f59e0b"}>
                                            {user.isVerified ? 'Activo' : 'Inactivo'}
                                        </Pill>
                                    </UsersTableBodyColumn>
                                    <UsersTableBodyColumn>
                                        <span style={{
                                            padding: '4px 12px',
                                            backgroundColor: '#f3f4f6',
                                            borderRadius: '6px',
                                            fontSize: '12px',
                                            fontWeight: '500',
                                            color: '#374151'
                                        }}>
                                            {user.role}
                                        </span>
                                    </UsersTableBodyColumn>
                                    <UsersTableBodyColumn>
                                        {user.organization ? (
                                            <span style={{
                                                padding: '4px 12px',
                                                backgroundColor: '#eff6ff',
                                                borderRadius: '6px',
                                                fontSize: '12px',
                                                fontWeight: '500',
                                                color: '#1e40af'
                                            }}>
                                                {user.organization}
                                            </span>
                                        ) : '-'}
                                    </UsersTableBodyColumn>
                                    <UsersTableBodyColumn style={{ width: '80px' }}>
                                        <Button
                                            outline
                                            width="40px"
                                            height="40px"
                                            onClick={() => {
                                                window.location.href = `/admin/user-edit/${user._id}`;
                                            }}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderColor: '#028322',
                                                color: '#028322'
                                            }}
                                        >
                                            <FiEdit size="1rem" />
                                        </Button>
                                    </UsersTableBodyColumn>
                                </UsersTableRow>
                            ))
                        )}
                    </UsersTableBody>
                </UsersTable>
            </div>
        </UserContainer>
    );
}
